export const isSameDay = (firstDate, secondDate) => {
	if (!firstDate || !secondDate) return false

	return (
		firstDate.getFullYear() === secondDate.getFullYear() &&
		firstDate.getMonth() === secondDate.getMonth() &&
		firstDate.getDate() === secondDate.getDate()
	)
}

export const timePopperModifiers = [
	{
		name: 'sameWidth',
		enabled: true,
		phase: 'beforeWrite',
		requires: ['computeStyles'],
		fn: ({ state }) => {
			if (state) {
				state.styles.popper.width = `${state.rects.reference.width}px`
			}
		},
		effect: ({ state }) => {
			state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`
			return () => {}
		}
	}
]

export const createRangeDayClassName = (startDateValue, endDateValue) => date => {
	const isRangeStart = isSameDay(date, startDateValue)
	const isRangeEnd = isSameDay(date, endDateValue)

	if (isRangeStart && isRangeEnd) {
		return 'custom-range-start custom-range-end'
	}

	if (isRangeStart) {
		return 'custom-range-start'
	}

	if (isRangeEnd) {
		return 'custom-range-end'
	}

	if (startDateValue && endDateValue && date > startDateValue && date < endDateValue) {
		return 'custom-in-range'
	}

	return undefined
}

export const addMonthsPreservingDay = (date, monthsToAdd = 1) => {
	if (!date || Number.isNaN(new Date(date).getTime())) return null

	const sourceDate = new Date(date)
	const sourceDay = sourceDate.getDate()
	const result = new Date(sourceDate)

	result.setDate(1)
	result.setMonth(result.getMonth() + monthsToAdd)

	const lastDayOfTargetMonth = new Date(
		result.getFullYear(),
		result.getMonth() + 1,
		0
	).getDate()

	result.setDate(Math.min(sourceDay, lastDayOfTargetMonth))
	return result
}